import React from 'react';
import { showToast } from './Toast';

function Contact() {
  const copyToClipboard = (text, message) => {
    navigator.clipboard.writeText(text).then(() => {
      showToast(message);
    });
  };

  const contactMethods = [
    {
      icon: 'fab fa-line',
      bgColor: 'bg-brand-100',
      textColor: 'text-brand-600',
      label: 'LINE Official / Order',
      value: 'NUTCHEEFUL',
      buttonText: 'Copy ID',
      message: 'Line ID คัดลอกแล้ว!'
    },
    {
      icon: 'fas fa-phone-alt',
      bgColor: 'bg-brand-100',
      textColor: 'text-brand-600',
      label: 'Direct Phone Line',
      value: '094-446-2974',
      buttonText: 'Copy Tel',
      message: 'เบอร์โทรศัพท์คัดลอกแล้ว!'
    },
    {
      icon: 'fab fa-instagram',
      bgColor: 'bg-brand-100',
      textColor: 'text-brand-600',
      label: 'Instagram Official',
      value: '@davigreekyogurt',
      buttonText: 'Copy IG',
      message: 'Instagram คัดลอกแล้ว!'
    }
  ];

  return (
    <section id="contact" className="py-20 lg:py-24 bg-[#FAFCFE] border-b border-brand-200/70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">

          {/* Left Column: Contact details */}
          <div className="lg:col-span-6 space-y-6">
            <div className="inline-flex items-center gap-2 text-brand-600">
              <span className="text-[11px] uppercase tracking-[0.25em] font-bold">
                Order & Inquiries
              </span>
              <svg className="w-4 h-4 text-brand-500 transform rotate-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M4 20c4-4 8-9 16-16" />
                <path d="M10 8c-2 0-3 2-3 2s2 1 3 0" fill="currentColor" fillOpacity="0.25" />
                <path d="M14 12c-2 0-3 2-3 2s2 1 3 0" fill="currentColor" fillOpacity="0.25" />
              </svg>
            </div>

            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal text-brand-900 tracking-tight leading-tight">
              Get In Touch & Order
            </h2>
            
            <p className="text-sm sm:text-base text-brand-700/90 font-light leading-relaxed">
              เราพร้อมส่งมอบความสดชื่นถึงบ้านคุณทุกวัน! สามารถแอดไลน์เพื่อสั่งซื้อ จัดเซ็ตของขวัญ หรือสอบถามรอบจัดส่งได้ทันที
            </p>

            <div className="space-y-3.5 pt-3">
              {contactMethods.map((method, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-4 bg-white border border-brand-200/80 rounded-2xl shadow-2xs hover:shadow-sm transition-all"
                >
                  <div className="flex items-center space-x-3.5">
                    <div className={`w-10 h-10 ${method.bgColor} ${method.textColor} rounded-full flex items-center justify-center text-base`}>
                      <i className={method.icon}></i>
                    </div>
                    <div>
                      <span className="text-[10px] text-brand-500 uppercase tracking-wider block font-medium">
                        {method.label}
                      </span>
                      <span className="text-sm font-semibold text-brand-900">
                        {method.value}
                      </span>
                    </div>
                  </div>
                  
                  <button
                    onClick={() => copyToClipboard(method.value, method.message)}
                    className="text-xs font-semibold text-brand-600 hover:text-brand-800 bg-brand-50/70 hover:bg-brand-100 border border-brand-200 px-3.5 py-1.5 rounded-full shadow-2xs transition-all uppercase tracking-wider"
                  >
                    {method.buttonText} <i className="far fa-copy ml-1 text-[10px]"></i>
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column: Packaging Image */}
          <div className="lg:col-span-6 flex justify-center">
            <div className="bg-white p-6 sm:p-8 rounded-3xl border border-brand-200/80 shadow-md max-w-md sm:max-w-lg w-full relative overflow-hidden flex flex-col items-center text-center">
              <div className="rounded-2xl overflow-hidden border border-brand-100 shadow-2xs bg-brand-50 w-full">
                <img
                  src="/DAVI.png"
                  alt="DA'VI Artisanal Packaging"
                  className="w-full h-auto object-cover max-h-[460px] transform hover:scale-102 transition-transform duration-500"
                />
              </div>
              <p className="mt-6 text-xs sm:text-sm font-serif italic text-brand-700 tracking-wide">
                "Crafted with love, delivered with care in our eco-friendly packaging"
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Contact;
